"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActivityFeedWebsocketToken = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const react_1 = require("react");
const models_1 = require("../../../models");
const useGenerateWebsocketToken_1 = require("../../../util/socket/useGenerateWebsocketToken");
const useShipmentToken_1 = require("../api/useShipmentToken");
const isShipUserID = (id) => id?.startsWith('U-') ?? false;
const useActivityFeedWebsocketToken = (entities) => {
    const { state: { shipmentToken, token, user }, } = (0, frontend_infra_auth_1.useAuth)();
    const generateWebsocketTokenAPI = (0, useGenerateWebsocketToken_1.useGenerateWebsocketToken)();
    const isShipUser = isShipUserID(user?._id);
    const shipmentEntity = entities.find((entity) => entity.type === 'shipment');
    const bookingEntity = entities.find((entity) => entity.type === 'booking');
    const shipmentTokenQuery = (0, useShipmentToken_1.useShipmentToken)(shipmentEntity?.id, shipmentEntity != null && !shipmentToken && isShipUser);
    const [shipmentWebsocketToken, setShipmentWebsocketToken] = (0, react_1.useState)();
    const [bookingWebsocketToken, setBookingWebsocketToken] = (0, react_1.useState)();
    const websocketApp = isShipUser ? models_1.WebsocketApp.ship : models_1.WebsocketApp.tms;
    const initializeSocketToken = async () => {
        if (!isShipUser) {
            if (shipmentEntity != null) {
                setShipmentWebsocketToken(token);
            }
            if (bookingEntity != null) {
                setBookingWebsocketToken(token);
            }
        }
        else {
            if (shipmentEntity != null) {
                if (shipmentToken) {
                    setShipmentWebsocketToken(shipmentToken);
                }
                else if (shipmentTokenQuery.data?.token != null) {
                    setShipmentWebsocketToken(shipmentTokenQuery.data.token);
                }
            }
            if (bookingEntity != null) {
                const { token: generatedToken } = await generateWebsocketTokenAPI.mutateAsync({
                    type: bookingEntity.type,
                    referenceID: bookingEntity.id,
                });
                setBookingWebsocketToken(generatedToken);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        initializeSocketToken();
    }, [shipmentToken, token, ...entities.map(({ id }) => id), user?._id, shipmentTokenQuery.data]);
    return { shipmentWebsocketToken, bookingWebsocketToken, websocketApp };
};
exports.useActivityFeedWebsocketToken = useActivityFeedWebsocketToken;
//# sourceMappingURL=useActivityFeedWebsocketToken.js.map